import request from 'superagent';
import {getDeviceSource} from 'utils/deviceSource';
import {domain} from 'ferries/helpers/common';

const registerUser = (payload) =>
  request
    .post(`${domain}/api/users`)
    .set({'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Device-Source': getDeviceSource()})
    .set('x-override-header', 'ferryscanner-web')
    .send(payload)
    .ok(({status}) => [201, 400].includes(status))
    .then(({body, status}) => ({body, status}));

const loginUser = (payload) =>
  request
    .post(`${domain}/api/users/login`)
    .set({'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Device-Source': getDeviceSource()})
    .set('x-override-header', 'ferryscanner-web')
    .send(payload)
    .ok(({status}) => [200, 201, 400, 404].includes(status))
    .then(({body, status}) => ({body, status}));

const logoutUser = () =>
  request
    .delete(`${domain}/api/users/login`)
    .set({'Content-Type': 'application/json', 'Accept': 'application/json'})
    .set('x-override-header', 'ferryscanner-web')
    .ok(({status}) => [204].includes(status))
    .then(({body, status}) => ({body, status}));

export {registerUser, loginUser, logoutUser};
